var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('advertising-series',{attrs:{"condition":_vm.condition,"loading":_vm.loading,"customTitle":_vm.customTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }